<vex-page-layout>
  <vex-page-layout-content>
    <div class="container">
      <form [formGroup]="loadingOrderForm">
        <div class="header">
          <h1># {{orderNumber}}</h1>
          <div class="header-buttons">
            <button
            class="ml-2"
            color="primary"
            mat-stroked-button
            routerLink="/transactions/loading-order">
            <mat-icon svgIcon="mat:cancel"></mat-icon> {{"CANCEL.TEXT"|translate}}
          </button>
          <button
          *ngIf="LoadingOrderStatus == 0"
          class="ml-2"
          id="sendAsDraft"
          color="draft"
          mat-stroked-button
          (click)="saveAsDraft()">
          <mat-icon svgIcon="mat:drafts"></mat-icon>{{"SAVE_AS_DRAFT.TEXT"|translate}}
        </button>
        <button
        *ngIf="LoadingOrderStatus != 0"
          class="ml-2"
          color="primary"
          mat-flat-button
          (click)="send()">
          <mat-icon svgIcon="mat:save"></mat-icon> {{"SAVE.TEXT"|translate}}
        </button>
       
            <button
            *ngIf="LoadingOrderStatus == 0"
              class="ml-2"
              color="primary"
              mat-flat-button
              (click)="send()">
              <mat-icon svgIcon="mat:send"></mat-icon>{{"SEND.TEXT"|translate}}
            </button>
           
           
          </div>
        </div>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"FROM_FACTORY.TEXT"|translate}}</mat-card-title>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"FACTORY.TEXT"|translate}}</mat-label>
              <input
                matInput
                placeholder="Search Factory"
                formControlName="searchFactory" />

              <mat-select #factorySelect required formControlName="factoryId">
                <mat-option
                  *ngFor="let factory of filteredfactories"
                  [value]="factory.id">
                  {{ factory.code }} - {{ factory.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"TO_CLIENT.TEXT"|translate}}</mat-card-title>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"CLIENT_NAME.TEXT"|translate}}</mat-label>
              <input
                matInput
                placeholder="Search Client"
                formControlName="searchCustomer" />

              <mat-select #customerSelect required formControlName="customerId">
                <mat-option
                  *ngFor="let customer of filteredCustomers"
                  [value]="customer.id">
                  {{ customer.code }} - {{ customer.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"LOCATION.TEXT"|translate}}</mat-label>
              <mat-select formControlName="customerAddressId" required>
                <mat-option
                  *ngFor="let location of customerLocations"
                  [value]="location.id"
                  >{{ location.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"PRODUCT_VEHICLE_DETAILS.TEXT"|translate}}</mat-card-title>
            <div class="row">
              <!-- <mat-form-field appearance="outline" class="half-width">
            <mat-label>Product</mat-label>
            <mat-select required formControlName="productId">
              <mat-option
                *ngFor="let product of products"
                [value]="product.id"
                >{{ product.name }}</mat-option
              >
            </mat-select>
          </mat-form-field> -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"PRODUCT.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  placeholder="Search Product"
                  formControlName="searchProduct" />

                <mat-select #productSelect required formControlName="itemId">
                  <mat-option
                    *ngFor="let product of filteredProducts"
                    [value]="product.id">
                    {{ product.code }} - {{ product.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{ "QUANTITY.TEXT" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="quantity"
                  required
                  placeholder="Enter quantity"
                  type="number" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TYPE_OF_VEHICLE.TEXT"|translate}}</mat-label>
                <mat-select
                formControlName="vehicleType">
                <mat-option
                *ngFor="let vehicle of vehicleType"
                [value]="IVehicleTypes[vehicle]"> <!-- Access enum value -->
                {{ (vehicle.toUpperCase() + '.TEXT')|translate }} <!-- Display enum key -->
                </mat-option>
              </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <mat-card-title>{{"ADDITIONAL_DETAILS.TEXT"|translate}}</mat-card-title>

            <div class="row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"CUSTOMER_REFERENCE_NO.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  formControlName="customerRefNo"
                  placeholder="Enter Reference No"
                  required />
              </mat-form-field>
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TRANSACTION_DATE.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  formControlName="transactionDate"
                  [matDatepicker]="picker" />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <!-- <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"TRANSPORTER.TEXT"|translate}}</mat-label>
              <mat-select required formControlName="transporterId">
                <mat-option
                  *ngFor="let transporter of transporters"
                  [value]="transporter.id"
                  >{{ transporter.name }}</mat-option
                >
              </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{"TRANSPORTER.TEXT"|translate}}</mat-label>
              <input
                matInput
                #inputTransporterRef
                placeholder="Search Transporter"
                (input)="filterTransporters($event)" />
              <mat-select
                #transporterSelect
                required
                formControlName="transporterId"
                (selectionChange)="clearSearchText()">
                <mat-option
                  *ngFor="let transporter of filteredTransporters"
                  [value]="transporter.id">
                  {{ transporter.name }} - {{transporter.code}}
                </mat-option>
              </mat-select>
              <div matSuffix class="flex items-center space-x-2">
                <button mat-icon-button (click)="removeTransporterFilter($event)" aria-label="Clear selection">
                  <mat-icon svgIcon="mat:delete"></mat-icon>
                </button>
              </div>
            </mat-form-field>
            <div class="row">
              <!-- <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TRUCK.TEXT"|translate}}</mat-label>
                <mat-select required formControlName="vehicleId" (selectionChange)="selectOption($event,1)">
                  <mat-option
                    *ngFor="let vehicle of vehicles"
                    [value]="vehicle.id"
                    >{{ vehicle.name }}
                    </mat-option
                  >
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"DRIVER.TEXT"|translate}}</mat-label>
                <mat-select required formControlName="driverId">
                  <mat-option
                    *ngFor="let driver of drivers"
                    [value]="driver.id"
                    >{{ driver.firstName }} {{ driver.lastName }}</mat-option
                  >
                </mat-select>
              </mat-form-field> -->

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"DRIVER.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  #inputDriverRef
                  placeholder="Search Driver"
                  (input)="filterDrivers($event)" />
                <mat-select
                  #driverSelect
                  required
                  formControlName="driverId"
                  (selectionChange)="clearSearchText()">
                  <mat-option
                    *ngFor="let driver of filteredDrivers"
                    [value]="driver.id"
                    [disabled]="shouldDisable(driver)">
                    {{ driver.firstName }} {{ driver.lastName }} ( {{driver.residenceNumber}} ) 
                  </mat-option>
                </mat-select>
                <div matSuffix class="flex items-center space-x-2">
                  <button mat-icon-button (click)="removeDriverFilter($event)" aria-label="Clear selection">
                    <mat-icon svgIcon="mat:delete"></mat-icon>
                  </button>
                </div>
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>{{"TRUCK.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  #inputVehicleRef
                  placeholder="Search Vehicle"
                  (input)="filterVehicles($event)"
                />
                <mat-select
                #vehicleSelect
                 required formControlName="vehicleId" (selectionChange)="clearSearchText()">
                  <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
                    {{ vehicle.name }}
                  </mat-option>
                </mat-select>
                <div matSuffix class="flex items-center space-x-2">
                  <button mat-icon-button (click)="removeVehicleFilter($event)" aria-label="Clear selection">
                    <mat-icon svgIcon="mat:delete"></mat-icon>
                  </button>
                </div>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </vex-page-layout-content>
</vex-page-layout>
